import { Component, OnInit } from '@angular/core';
import {
	faAngleRight,
	faBox,
	faBoxOpen,
	faExclamationCircle,
	faList,
	faPlus,
	faTentArrowTurnLeft,
	faTableList,
	faPerson,
	faSortDown,
	faSortUp,
	faXmark,
} from '@fortawesome/free-solid-svg-icons';
import { ciInterface } from 'src/app/util/interfaces/ci';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { StockPageService } from 'src/app/page/stock/stock-page/service/stock-page.service';
import { stockInterface } from 'src/app/util/interfaces/stock';
import { iacOptionInterface } from 'src/app/page_component_item/input-with-autocomplete/input-with-autocomplete.component';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { PermissionService } from 'src/app/util/services/permission/permission.service';
import { Router } from '@angular/router';
import { LocalityInterface } from 'src/app/util/interfaces/locality';
import { ciRelationshipInterface } from 'src/app/util/interfaces/ciRelationship';
import { ShkDate } from 'shk-date';
import { GlobalService } from 'src/app/services/global/global.service';
import { mspTableHeaderI } from 'src/app/page_component_item/msp-table/msp-table.component';
import { enduserInterface } from 'src/app/util/interfaces/enduser';
import { DateService } from 'src/app/services/date/date.service';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';
@Component({
	selector: 'app-stock-page',
	templateUrl: './stock-page.component.html',
	styleUrls: ['./stock-page.component.scss'],
})
export class StockPageComponent implements OnInit {
	icons = {
		faPlus: faPlus,
		faAngleRight: faAngleRight,
		faBoxOpen: faBoxOpen,
		faList: faList,
		faTentArrowTurnLeft: faTentArrowTurnLeft,
		faExclamationCircle: faExclamationCircle,
		faTableList: faTableList,
		faPerson: faPerson,
		faSortDown: faSortDown,
		faSortUp: faSortUp,
		faXmark: faXmark,
	};

	labels: LabelsInterface = {
		lbl_selecione_uma_opcao: '',
		lbl_search_person: '',
		lbl_geral_selecione: 'Select',
		lbl_status_estoque: 'Stock',
		lbl_estoque_navigation_movimentacao_emprestimo: 'Stock movement/Lending',
		lbl_geral_devolucao: 'Return',
		lbl_consultar_estoque: 'See stock',
		lbl_geral_home: 'Home',
		lbl_devolucao_pendente: 'Pending return',
		lbl_geral_devolver: 'Return',
		lbl_geral_identificacao: 'Identification',
		lbl_geral_disponiveis: 'Available',
		lbl_geral_nota_fiscal: 'Invoice',
		lbl_chamado: 'Request',
		lbl_geral_entrada: 'Entry',
		lbl_geral_localidade: 'Location',
		lbl_geral_tipo: 'Type',
		lbl_geral_data_entrada: 'Entry date',
		lbl_geral_data_saida: 'Exit date',
		lbl_geral_data_emprestimo: 'Lending date',
		lbl_geral_return_date: 'Return date',
		lbl_geral_observacoes: 'Observations',
		lbl_geral_inserir: 'Insert',
		lbl_geral_busca: 'Search',
		lbl_geral_ultima_atualizacao: 'Last update',
		lbl_stock_historico_do: 'History of',
		lbl_usuario_responsavel: 'Responsible user',
		lbl_data_mov: 'Date of this mov.',
		lbl_successful_updated: 'Successful updated',
		lbl_geral_saida: '',
		lbl_data_prevista_devolucao: '',
		lbl_stock_emprestimo: '',
		lbl_see_more: '',
		lbl_geral_pesquisar_usuario: 'Search user',
		lbl_geral_quantidade: '',
		lbl_edocs_carregando: 'Loading',
		lbl_preencha_todos_asteriscos: '',
		lbl_geral_relatorio_estoque: 'Inventory Report',
		lbl_stock_visualizar_sem_permissao: 'You are not allowed to view the stock',
		lbl_data_movimentacao_nao_maior_hoje: '',
		lbl_data_retorno_nao_menor_movimentacao: '',
		lbl_security_nenhum_registro: '',
		lbl_filtros_de_busca: '',
		lbl_visualizar_mapa_relacionamento: '',
		lbl_geral_ativo: 'Active',
		lbl_status_desativado: 'Inactive',
		lbl_geral_location_selecione: '',
		lbl_selecione_para_continuar: '',
		lbl_geral_nao_encontrado: '',
		lbl_geral_data_retorno: '',
		lbl_geral_emprestimo: '',
		lbl_cmdb_ci_sem_localidade: '',
		lbl_emprestimo_sem_data_de_devolucao: '',
		lbl_geral_item_emprestado: 'The item has already been borrowed, to return it, use the menu on the left side',
		lbl_geral_usuarios: '',
		lbl_geral_inicio: '',
		lbl_geral_sim: '',
		lbl_geral_nao: '',
		lbl_geral_pesquisar: '',
		lbl_pendente_devolucao: '',
		lbl_asset_alocacao: '',
		lbl_geral_avaliar: 'Evaluate',
	};

	today: Date;

	constructor(
		private StockPageService: StockPageService,
		private LabelsService: LabelsService,
		private NotificationService: NotificationService,
		private PermissionService: PermissionService,
		private Router: Router,
		public ProfileService: ProfileService,
		public DateService: DateService
	) {}

	isLoadingLabels = true;
	isLoadingAvailableUsers = true;
	isLoadingLendings = true;
	isLoadingLendingsButton = false;
	isLoadingStocks = false;
	isUpdatindStocks = false;
	isLoadingUserLendings = false;
	isOpenModalEvaluationMSP = false;

	// Localidades
	locationsList: LocalityInterface[] = [];
	listLocationsIAC: iacOptionInterface[] = [];
	isLoadingLocations = true;
	clearValuesLocation = false;
	placeholderLocation = '';
	selectedLocationId = '';

	selectedEntry = 'not-chosen';
	selectedMainOption = 'not-chosen';

	request = '';

	availableUsers: enduserInterface[] = [];
	availableUsersIAC: iacOptionInterface[] = [];
	selectedUserId = '';
	searchOnlyPending = true;
	userLendings: ciRelationshipInterface[] = undefined;

	userLendingsSort = 'name';
	userSortDown = true;

	selectedCi: ciInterface['ciArray'][number] = {
		identification: '',
		cmdb_id: '',
		id: '',
		idLocation: -1,
		type: 'Mold',
	};

	instaSelectFilters: { name: 'Status'; values: 'Expired'; lock: true; unchangeable: true }[] = [];

	stockData: stockInterface;
	stockList: stockInterface[] = [];
	pendingLending: stockInterface[] = [];
	filteredPendingLending: stockInterface[] = [];
	iacPendingLending: iacOptionInterface[] = [];
	oldMovement = {
		lastIn: 1,
		lastOut: -1,
	};
	alertFields = {
		userResponsible: false,
		idTypeMovement: false,
		movementDate: false,
		expectedReturnDate: false,
		returnDate: false,
	};

	stockPendingLendingMspTableHeader: mspTableHeaderI[] = [
		{ name: 'identification', value: 'lbl_geral_identificacao', colType: 'text' },
		{ name: 'request', value: 'lbl_geral_chamado', colType: 'text' },
		{ name: 'userResponsible', value: 'lbl_usuario_responsavel', colType: 'text' },
		{ name: 'expectedReturnDate', value: 'lbl_data_prevista_devolucao', colType: 'date' },
		{ name: 'available', value: 'lbl_geral_quantidade', colType: 'text' },
		{ name: 'icon', value: 'lbl_bulletin_actions', colType: 'icon' },
	];

	usersMspTableHeader: mspTableHeaderI[] = [{ name: 'name', value: 'lbl_geral_nome', colType: 'text' }];
	userMspTablePaginationStart = 0;
	userMspTablePaginationEnd = 0;

	ngOnInit(): void {
		this.today = new Date();
		this.LabelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			this.isLoadingLabels = false;

			if (!this.PermissionService.hasPermission('stock_visualizar')) {
				this.NotificationService.setNotificationMessage(this.labels.lbl_stock_visualizar_sem_permissao);
				this.Router.navigate(['/404']);
			}
		});

		this.getAllLocations();

		this.StockPageService.getAvailableUsers().subscribe((availableUsers) => {
			this.availableUsers = availableUsers;
			this.availableUsers.sort((a, b) => {
				if (a.fullName > b.fullName) return 1;
				if (a.fullName < b.fullName) return -1;
				return 0;
			});
			for (const user of availableUsers) {
				const userIAC: iacOptionInterface = {
					name: user.fullName,
					value: user.id,
				};
				this.availableUsersIAC.push(userIAC);
			}
			this.isLoadingAvailableUsers = false;
		});

		//this.getPendingLending();
		//this.isLoadingLendings = false;
	}

	// Todos as localidades na lista
	getAllLocations() {
		this.StockPageService.getAllLocations().subscribe((locations) => {
			this.listLocationsIAC = [];
			this.locationsList = [];
			this.locationsList = locations;
			for (const item of this.locationsList) {
				const newIacOptionLocation: iacOptionInterface = {
					name: item.name_site + ', ' + item.location,
					value: item.id,
					commonGroup: item.active === 1 ? this.labels.lbl_geral_ativo : this.labels.lbl_status_desativado,
				};
				this.listLocationsIAC.push(newIacOptionLocation);
			}
			this.isLoadingLocations = false;
		});
	}

	clearLendingPage() {
		this.filteredPendingLending = [];
		this.isLoadingLendings = true;
		this.clearValuesLocation = true;
	}

	getPendingLending(): void {
		this.isLoadingLendingsButton = true;

		if (this.selectedUserId === '') {
			this.NotificationService.setNotificationMessage(this.labels.lbl_preencha_todos_asteriscos);
			this.isLoadingLendingsButton = false;
		} else {
			this.pendingLending = [];
			this.isLoadingLendings = true;
			this.filteredPendingLending = [];
			this.StockPageService.getPendingLendings(this.selectedLocationId, this.selectedUserId, this.request).subscribe(
				(stockRes) => {
					this.pendingLending = stockRes;
					this.filteredPendingLending = stockRes;
					if (this.pendingLending.length === 0) {
						this.NotificationService.setNotificationMessage(this.labels.lbl_geral_nao_encontrado);
						this.isLoadingLendingsButton = false;
					} else {
						this.iacPendingLending = [];
						for (const lend of this.pendingLending) {
							const lendIAC: iacOptionInterface = {
								name: `${lend.relatedCi.identification} (${lend.relatedCi.location}) (${lend.userResponsible})`,
								value: lend.idMovement,
							};
							this.isLoadingLendings = false;
							this.isLoadingLendingsButton = false;
							this.iacPendingLending.push(lendIAC);
							let date: Date;
						}
					}
				},
				(error) => {
					this.isLoadingLendings = false;
				}
			);
		}
	}

	selectCiHistory(ciDataEvent: string): void {
		const ciData: ciInterface['ciArray'][number] = JSON.parse(ciDataEvent);
		this.selectedMainOption = 'Stock';
		this.isLoadingStocks = true;
		this.StockPageService.searchStockItemLogs(ciData.cmdb_id).subscribe((stocks) => {
			this.stockList = JSON.parse(JSON.stringify(stocks));
			this.stockData = JSON.parse(JSON.stringify(stocks[0]));

			if (
				this.stockData.relatedCi.location == '' ||
				this.stockData.relatedCi.idLocation == undefined ||
				this.stockData.relatedCi.idLocation == 0 ||
				this.stockData.relatedCi.idLocation == 0
			) {
				this.NotificationService.setNotificationMessage(this.labels.lbl_cmdb_ci_sem_localidade);
				this.Router.navigate(['/stock']);
				this.selectedEntry = 'Movement';
				this.selectedMainOption = 'Search';
			}

			if (this.stockData.relatedCi.isConsumable === false || this.stockData.relatedCi.isConsumable === 0) {
				if (this.stockList[0].available === 1 || this.stockData.idUserResponsible === '') {
					this.stockList[0].in = 0;
					this.stockList[0].out = 1;
					this.stockList[0].idTypeMovement = '3';
					this.stockData.in = 0;
					this.stockData.out = 1;
					this.stockData.idTypeMovement = '3';
					this.stockData.observation = '';
					this.stockData.movementDate = this.today;
					this.stockData.expectedReturnDate = this.today;
					this.isLoadingStocks = false;
					this.isUpdatindStocks = false;
				} else if (this.stockList[0].available === 0) {
					this.NotificationService.setNotificationMessage(this.labels.lbl_geral_item_emprestado);
					this.isLoadingStocks = false;
					this.isUpdatindStocks = false;
					this.cleanStockData();
					this.selectedMainOption = 'Search';
					return false;
				}
			} else {
				this.cleanStockData();
				this.isLoadingStocks = false;
				this.isUpdatindStocks = false;
			}
		});
	}

	selectCiHistoryToLending(idCi: string): void {
		this.isLoadingLendings = true;
		this.selectedMainOption = 'Search';
		this.getPendingLending();
	}

	selectCiData(ciDataEvent: string): void {
		const ciData: ciInterface['ciArray'][number] = JSON.parse(ciDataEvent);
		this.isLoadingStocks = true;
		this.selectedMainOption = 'Stock-Display';

		this.StockPageService.searchStockItem(ciData.cmdb_id).subscribe((stock) => {
			this.stockData = stock;
			this.isLoadingStocks = false;
		});
	}

	handleMovement(qnt: number): void {
		if (isNaN(Number.parseFloat(qnt.toString()))) {
			this.resetMovement();
			return;
		}

		qnt = Number.parseInt(qnt.toString());

		if (
			this.stockData.idTypeMovement === '2' ||
			this.stockData.idTypeMovement === '3' ||
			this.stockData.idTypeMovement === '4' ||
			this.stockData.idTypeMovement === '5'
		)
			qnt = qnt * -1;

		const oldMovementName = `last${this.stockData.idTypeMovement === '1' ? 'In' : 'Out'}`;
		const diff = qnt - this.oldMovement[oldMovementName];
		this.oldMovement[oldMovementName] = qnt;
		this.stockData.available += diff;
	}

	resetMovement(): void {
		this.stockData.available = Number.parseInt(this.stockList[0].available.toString());
		this.stockData.in = 1;
		this.stockData.out = 1;
		this.oldMovement.lastIn = 1;
		this.oldMovement.lastOut = -1;
	}

	updateStock(): void {
		if (this.isUpdatindStocks || !this.isDateCorrect() || !this.isFieldsFulfilled()) return;

		if (
			!this.PermissionService.hasPermission('stock_inserir') &&
			!this.PermissionService.hasPermission('stock_editar') &&
			!this.PermissionService.hasPermission('stock_deletar')
		) {
			this.NotificationService.setNotificationMessage('_Usuário sem permissão para realizar movimentações');
			return;
		}

		this.isUpdatindStocks = true;
		this.StockPageService.updateStock(this.stockData).subscribe((res) => {
			this.StockPageService.searchStockItemLogs(this.stockData.relatedCi.cmdb_id).subscribe((stocks) => {
				this.stockList = JSON.parse(JSON.stringify(stocks));

				if (this.stockData.idTypeMovement === '4') {
					this.selectedMainOption = 'Search';
					this.selectedEntry = 'Lending';
					this.getPendingLending();
				}
				if (this.stockData.idTypeMovement === '3') {
					if (this.stockData.relatedCi.isConsumable === false || this.stockData.relatedCi.isConsumable === 0) {
						this.selectedMainOption = 'Search';
						this.cleanStockData();
					}
					this.getPendingLending();
				}
				this.cleanStockData();
				this.isUpdatindStocks = false;
				this.NotificationService.setNotificationMessage(this.labels.lbl_successful_updated);
			});
		});
	}

	cleanStockData(): void {
		this.resetMovement();
		this.stockData.document = '';
		this.stockData.request = '';
		this.stockData.observation = '';
		this.stockData.idUserResponsible = '-1';
		this.stockData.idTypeMovement = '-1';
		this.stockData.movementDate = this.today;
		this.stockData.expectedReturnDate = this.today;
		this.stockData.available = Number.parseInt(this.stockList[0].available.toString());
	}

	getStockHistory(): void {
		if (!this.PermissionService.hasPermission('stock_visualizar_relatorio')) {
			this.NotificationService.setNotificationMessage('_Usuário sem permissão para visualizar relatório');
			return;
		}

		this.stockList = [];
		this.isLoadingStocks = true;
		this.selectedMainOption = 'Stock-History';
		this.StockPageService.searchStockItemLogs(this.stockData.relatedCi.cmdb_id).subscribe((stockList) => {
			this.stockList = stockList;
			this.isLoadingStocks = false;
			this.isLoadingLendings = false;
		});
	}

	filterPendingLending(input: string): void {
		this.iacPendingLending = [];
		this.filteredPendingLending = [];
		input = input.toLowerCase();
		for (const lend of this.pendingLending) {
			const lendDisplayName = `${lend.relatedCi.identification} (${lend.relatedCi.location}) (${lend.userResponsible})`;
			if (
				lend.userResponsible.toLocaleLowerCase().includes(input) ||
				lend.relatedCi.identification.toLocaleLowerCase().includes(input) ||
				lend.relatedCi.location.toString().toLocaleLowerCase().includes(input) ||
				(<any>lendDisplayName)
					.replaceAll('(', '')
					.replaceAll(')', '')
					.trim()
					.toLocaleLowerCase()
					.includes((<any>input).replaceAll('(', '').replaceAll(')', '').trim())
			) {
				this.filteredPendingLending.push(lend);
			}
		}
	}

	setReturn(index: number): void {
		if (!this.PermissionService.hasPermission('stock_devolver')) {
			this.NotificationService.setNotificationMessage('_Usuário sem permissão para devolver item');
			return;
		}

		const stock = this.filteredPendingLending[index];
		this.stockData = stock;
		this.stockData.observation = '';
		this.stockList = [];
		this.stockList.push(JSON.parse(JSON.stringify(stock)));
		this.stockData.idTypeMovement = '4';
		this.stockData.in = 1;
		this.selectedMainOption = 'Stock';
		this.selectedEntry = 'Return';
	}

	isFieldsFulfilled(): boolean {
		let isFulfilled = true;
		if (this.stockData.idTypeMovement === '' || this.stockData.idTypeMovement === '-1') {
			isFulfilled = false;
			this.alertFields.idTypeMovement = true;
		}
		if (this.stockData.idUserResponsible === '' || this.stockData.idUserResponsible === '-1') {
			isFulfilled = false;
			this.alertFields.userResponsible = true;
		}
		if (this.stockData.movementDate === '') {
			isFulfilled = false;
			this.alertFields.movementDate = true;
		}
		if (this.stockData.idTypeMovement === '3' && this.stockData.expectedReturnDate === '' && this.stockData.relatedCi.location == '') {
			isFulfilled = false;
			this.alertFields.expectedReturnDate = true;
		}
		if (this.stockData.idTypeMovement === '4' && this.stockData.returnDate === '') {
			isFulfilled = false;
			this.alertFields.returnDate = true;
		}

		if (!isFulfilled) {
			this.NotificationService.setNotificationMessage(this.labels.lbl_preencha_todos_asteriscos);
		}
		return isFulfilled;
	}

	isDateCorrect(): boolean {
		let isCorrect = true;
		if (
			(this.stockData.idTypeMovement === '1' || this.stockData.idTypeMovement === '2' || this.stockData.idTypeMovement === '3') &&
			new Date(this.stockData.movementDate) > this.today
		) {
			this.alertFields.movementDate = true;
			this.NotificationService.setNotificationMessage(this.labels.lbl_data_movimentacao_nao_maior_hoje);
			isCorrect = false;
		}
		if (this.stockData.idTypeMovement === '3' && new Date(this.stockData.expectedReturnDate) < new Date(this.stockData.movementDate)) {
			this.alertFields.expectedReturnDate = true;
			this.NotificationService.setNotificationMessage(this.labels.lbl_data_retorno_nao_menor_movimentacao);
			isCorrect = false;
		}
		if (this.stockData.idTypeMovement === '4' && new Date(this.stockData.returnDate) > this.today) {
			this.alertFields.returnDate = true;
			this.NotificationService.setNotificationMessage(this.labels.lbl_data_movimentacao_nao_maior_hoje);
			isCorrect = false;
		}

		return isCorrect;
	}

	notifyText(string: string): void {
		this.NotificationService.setNotificationMessage(string);
	}

	cleanUserLendings(): void {
		this.userLendings = undefined;
	}

	getUserLendings(): void {
		if (this.isLoadingUserLendings) return;

		this.isLoadingUserLendings = true;
		this.StockPageService.getUserLending(this.selectedUserId).subscribe((userLendings) => {
			this.userLendings = userLendings;
			this.isLoadingUserLendings = false;
		});
	}

	sortUserLendCardsBy(sortedBy: string, sortDown: boolean): void {
		this.userSortDown = sortDown;
		this.userLendingsSort = sortedBy;
		if (sortedBy.includes('date') && <any>new Date(this.userLendings[0][sortedBy]) != 'Invalid Date') {
			this.userLendings.sort((a, b) => {
				return new Date(a[sortedBy]) > new Date(b[sortedBy]) ? (this.userSortDown ? 1 : -1) : this.userSortDown ? -1 : 1;
			});
		} else {
			this.userLendings.sort((a, b) => {
				if (a[sortedBy] > b[sortedBy]) return this.userSortDown ? 1 : -1;
				if (a[sortedBy] < b[sortedBy]) return this.userSortDown ? -1 : 1;
				return 0;
			});
		}
	}

	sortUserIAC(): void {
		this.availableUsersIAC.reverse();
	}

	navigateTo(to: string): void {
		this.Router.navigateByUrl(to);
	}

	// Função para fechar o modal ao ser clicado em áreas que não fazem parte do modal
	modalClose(event: Event, ignorePropagation: boolean): void {
		if (event.target === document.querySelector('#modalClose')) {
			this.isOpenModalEvaluationMSP = !this.isOpenModalEvaluationMSP;
		}
		if (ignorePropagation) {
			this.isOpenModalEvaluationMSP = !this.isOpenModalEvaluationMSP;
		}
	}

	openModalEvaluationMSP() {
		this.isOpenModalEvaluationMSP = !this.isOpenModalEvaluationMSP;
	}
	// Final Função para fechar o modal ao ser clicado em áreas que não fazem parte do modal
}
